import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import {
  BulkImportIndexResponse,
  BulkImportReserveResponse,
} from '@/repositories/generated';

const content: BulkImportIndexResponse[] = [
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'RESERVED',
    accountBulkImportInfo: {
      roleName: 'システム管理者',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'RESERVED',
    accountBulkImportInfo: {
      roleName: 'システム担当者',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'RESERVED',
    accountBulkImportInfo: {
      roleName: 'テナント管理者',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'RESERVED',
    accountBulkImportInfo: {
      roleName: 'テナント担当者',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'PROCESSING',
    accountBulkImportInfo: {
      roleName: 'アクワイアラ管理者',
      acquirerName: '株式会社〇〇',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'PROCESSING',
    accountBulkImportInfo: {
      roleName: 'アクワイアラ担当者',
      acquirerName: '株式会社〇〇',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'PROCESSING',
    accountBulkImportInfo: {
      roleName: '企業管理者',
      acquirerName: '株式会社〇〇',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'PROCESSING',
    accountBulkImportInfo: {
      roleName: '企業担当者',
      acquirerName: '株式会社〇〇',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'PROCESSING',
    accountBulkImportInfo: {
      roleName: '店舗管理者',
      acquirerName: '株式会社〇〇',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'PROCESSING',
    accountBulkImportInfo: {
      roleName: '店舗担当者',
      acquirerName: '株式会社〇〇',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'PROCESSING',
    accountBulkImportInfo: {
      roleName: 'バリューイシュア管理者',
      valueIssuerName: 'テストPay',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'PROCESSING',
    accountBulkImportInfo: {
      roleName: 'バリューイシュア担当者',
      valueIssuerName: 'テストPay',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'PROCESSING',
    accountBulkImportInfo: {
      roleName: 'ウォレットサービス管理者',
      valueIssuerName: 'テストPay',
      walletServiceName: 'テストウォレット',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: '山田 一郎',
    bulkImportStatus: 'PROCESSING',
    accountBulkImportInfo: {
      roleName: 'ウォレットサービス管理者',
      valueIssuerName: 'テストPay',
      walletServiceName: 'テストウォレット',
    },
  },
  {
    id: '1',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'ACCOUNT',
    fileName: 'テスト＿１.csv',
    createdBy: 'sysad_kasaharasan',
    bulkImportStatus: 'FAILED',
    accountBulkImportInfo: {
      roleName: 'ウォレットサービス管理者',
      valueIssuerName: 'テストPay',
      walletServiceName: 'テストウォレット',
    },
  },
  {
    id: '2',
    uploadDate: '2022-04-23T00:00:00+09:00',
    bulkImportCategory: 'COMPANY',
    fileName: 'test_2.csv',
    createdBy: 'Giro Yamada',
    bulkImportStatus: 'COMPLETED',
  },
  {
    id: '3',
    uploadDate: '2023-04-23T00:00:00+09:00',
    bulkImportCategory: 'SHOP',
    fileName: 'test_3_!-_.*().csv',
    createdBy: '左衛門 三郎',
    bulkImportStatus: 'FAILED',
  },
  {
    id: '4',
    uploadDate: '2024-04-23T00:00:00+09:00',
    bulkImportCategory: 'TERMINAL',
    fileName: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz.csv',
    createdBy: '野田 江川富士一二三四五左衛門助太郎',
    bulkImportStatus: 'PROCESSING',
  },
  {
    id: '4',
    uploadDate: '2024-04-23T00:00:00+09:00',
    bulkImportCategory: 'TERMINAL',
    fileName: 'A BCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz.csv',
    createdBy: 'A BCDEFGHIJKLMNOPQRSTUVWXYZ',
    bulkImportStatus: 'PROCESSING',
  },
  {
    id: '5',
    uploadDate: '2025-04-23T00:00:00+09:00',
    bulkImportCategory: 'PARTNER_WALLET_SHOP',
    fileName: 'test_5.csv',
    createdBy: '五郎',
    bulkImportStatus: 'COMPLETED',
  },
  {
    id: '6',
    uploadDate: '2026-04-23T00:00:00+09:00',
    bulkImportCategory: 'SHOP_SPLIT_PAYMENT',
    fileName: 'test_6.csv',
    createdBy: '六郎',
    bulkImportStatus: 'FAILED',
  },
  {
    id: '7',
    uploadDate: '2026-04-23T00:00:00+09:00',
    bulkImportCategory: 'SHOP_SPLIT_PAYMENT',
    fileName: 'test_error_404.csv',
    createdBy: '七郎',
    bulkImportStatus: 'FAILED',
  },
  {
    id: '8',
    uploadDate: '2026-04-23T00:00:00+09:00',
    bulkImportCategory: 'SMART_CODE_SHOP',
    fileName: 'test_8.csv',
    createdBy: undefined,
    bulkImportStatus: 'FAILED',
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const bulkImportGet = http.get(
  createMockEndpoint('/bulk_import'),
  async ({ request }) => {
    const url = new URL(request.url);
    await delay(500);
    const bulkImportCategoriesExists = url.searchParams.get('bulkImportCategories');
    const bulkImportStatusesExists = url.searchParams.get('bulkImportStatuses');
    const uploadedStartDateTimeExists = url.searchParams.get('uploadedStartDateTime');
    const uploadedEndDateTimeExists = url.searchParams.get('uploadedEndDateTime');

    if (bulkImportCategoriesExists || bulkImportStatusesExists || uploadedStartDateTimeExists || uploadedEndDateTimeExists) {
      return HttpResponse.json({
        content: loopContent.slice(3, 25),
        pageable: {
          sort: {
            empty: true,
            sorted: false,
            unsorted: true,
          },
          offset: 0,
          pageNumber: 0,
          pageSize: 20,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 20,
        size: 20,
        number: 0,
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        first: true,
        numberOfElements: 20,
        empty: false,
      }, { status: 200 });
    }
    // クエリパラメータなし
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);

const responsePost: BulkImportReserveResponse = {
  id: '1',
};

export const bulkImportPost = http.post(
  createMockEndpoint('/bulk_import'),
  async () => {
    await delay(500);
    return HttpResponse.json(responsePost, { status: 200 });
  },
);
